import React from 'react';
import { pipelineData } from '../../data/centralizedData';

const Pipeline = () => {
  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <h2 className="text-3xl font-bold text-gray-900">Investment Pipeline</h2>
      </div>

      <div className="bg-white p-6 rounded-xl border shadow-sm">
        <div className="grid grid-cols-4 gap-4 text-center">
          <div className="p-4">
            <div className="text-2xl font-bold text-red-600">{pipelineData.priorityBreakdown.high}</div>
            <div className="text-sm text-gray-600">High Priority</div>
          </div>
          <div className="p-4">
            <div className="text-2xl font-bold text-yellow-600">{pipelineData.priorityBreakdown.medium}</div>
            <div className="text-sm text-gray-600">Medium Priority</div>
          </div>
          <div className="p-4">
            <div className="text-2xl font-bold text-gray-600">{pipelineData.priorityBreakdown.low}</div>
            <div className="text-sm text-gray-600">Low Priority</div>
          </div>
          <div className="p-4">
            <div className="text-2xl font-bold text-green-600">{pipelineData.targetTimeline}</div>
            <div className="text-sm text-gray-600">Target Timeline</div>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {pipelineData.companies.map((company, index) => (
          <div key={index} className="bg-white p-8 rounded-xl border shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between mb-6">
              <div className="flex-1">
                <div className="flex items-center space-x-4 mb-3">
                  <h3 className="text-xl font-semibold text-gray-900">{company.name}</h3>
                  <span className="text-sm text-gray-500">•</span>
                  <span className="text-sm font-medium text-blue-600">{company.sector}</span>
                  <div className={`px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide ${
                    company.priority === 'high' ? 'bg-red-100 text-red-800 border border-red-200' :
                    company.priority === 'medium' ? 'bg-yellow-100 text-yellow-800 border border-yellow-200' :
                    'bg-gray-100 text-gray-800 border border-gray-200'
                  }`}>
                    {company.priority} Priority
                  </div>
                  <div className={`px-3 py-1 rounded-full text-xs font-medium ${
                    company.status === 'active' ? 'bg-green-100 text-green-800' :
                    company.status === 'evaluating' ? 'bg-blue-100 text-blue-800' :
                    company.status === 'new' ? 'bg-purple-100 text-purple-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {company.status}
                  </div>
                </div>
                <div className="text-gray-700 mb-4">
                  {company.description.split('|').map((paragraph, index) => (
                  <p key={index} className={index > 0 ? 'mt-3' : ''}>
                  {paragraph.trim()}
                  </p>
                  ))}
                </div>
                
                {company.investmentMetrics && company.investmentMetrics.length > 0 && (
                  <div className="mb-6">
                    <h4 className="font-medium text-gray-900 mb-3">Investment Metrics</h4>
                    <div className="overflow-x-auto">
                      <table className="w-full text-sm">
                        <thead>
                          <tr className="border-b border-gray-200 bg-gray-50">
                            <th className="text-left py-2 px-3 font-semibold text-gray-900">Metric</th>
                            <th className="text-left py-2 px-3 font-semibold text-gray-900">Category</th>
                            <th className="text-left py-2 px-3 font-semibold text-gray-900">Calculation</th>
                            <th className="text-left py-2 px-3 font-semibold text-gray-900">Benefit</th>
                          </tr>
                        </thead>
                        <tbody>
                          {company.investmentMetrics.map((metric, idx) => (
                            <tr key={idx} className="border-b border-gray-100">
                              <td className="py-2 px-3 font-medium text-gray-900">{metric.metric}</td>
                              <td className="py-2 px-3">
                                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                                  metric.category === 'Efficiency' ? 'bg-blue-100 text-blue-800' :
                                  metric.category === 'Income' ? 'bg-green-100 text-green-800' :
                                  metric.category === 'Contract' ? 'bg-yellow-100 text-yellow-800' :
                                  'bg-gray-100 text-gray-800'
                                }`}>
                                  {metric.category}
                                </span>
                              </td>
                              <td className="py-2 px-3 text-gray-600">{metric.calculation}</td>
                              <td className="py-2 px-3 text-gray-600">{metric.benefit}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  <div>
                    <h4 className="font-medium text-gray-900 mb-2">Investment Details</h4>
                    <div className="text-sm text-gray-600 space-y-1">
                      <div className="flex justify-between">
                        <span>Stage:</span>
                        <span className="font-medium">{company.stage}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Investment Amount:</span>
                        <span className="font-medium text-green-600">{company.investmentAmount}</span>
                      </div>
                      <div className="flex justify-between">
                        <span>Timeline:</span>
                        <span className="font-medium">{company.timeline}</span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h4 className="font-medium text-gray-900 mb-2">Next Steps</h4>
                    <p className="text-sm text-gray-700">{company.nextSteps}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Pipeline;